type ProgramIconProps = {
  size?: number
  color?: string
}

/** CDN の種別アイコン（workgroup.svg 等）と同じ線色（colorPalette に該当色なし） */
const DEFAULT_COLOR = '#888888'
/** CDN の種別アイコン（workgroup.svg 等）と同じ内部塗り色 */
const INNER_FILL = '#F2F2F2'

/**
 * プログラムを表すアイコン（旗印モチーフ）。
 * 「旗印を立てる」＝戦略テーマを表現する。束ねる構造はツリー側の
 * インデント・開閉アイコンに任せ、アイコンはテーマ性の表現に振り切る。
 * 種別アイコン（assets/icons/wbs-item-type/*.svg）と視覚的な重さを合わせるため、
 * 細い輪郭線＋薄い内部塗り（#F2F2F2）で描画する。
 * AG Grid の全行に描画されるセルでも使うため、emotion を介する SvgIcon ではなく
 * 生 SVG で軽量に描画する。
 */
export const ProgramIcon = ({
  size = 16,
  color = DEFAULT_COLOR,
}: ProgramIconProps) => (
  <svg
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="none"
    style={{ flexShrink: 0 }}
  >
    {/* 旗竿 */}
    <path d="M5.5 2.5v15" stroke={color} strokeWidth="1" />
    {/* 旗（右端に切り込みのあるペナント） */}
    <path
      d="M5.5 3.5H15.5L13.5 6.75L15.5 10H5.5Z"
      fill={INNER_FILL}
      stroke={color}
      strokeWidth="1"
    />
  </svg>
)
